<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/productionProcess/add')">新增</el-button>
        <el-button class="mr10" v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item prop="inspectionType" label="检验类型">
          <el-select v-model="searchForm.inspectionType" clearable filterable placeholder="请选择检验类型">
            <el-option v-for="(item, index) of inspectionTypeArr" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="productionDate" label="生产日期">
          <el-date-picker v-model="searchForm.productionDate" placeholder="请选择生产日期" type="date" clearable
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="specId" label="产品规格">
          <el-select v-model="searchForm.specId" clearable filterable placeholder="请选择产品规格">
            <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="checkResult" label="检查结果">
          <el-select v-model="searchForm.checkResult" clearable filterable placeholder="请选择检查结果">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="140" label="检验类型">
          <template #default="{row}">
            {{ formatInspectionType(row.inspectionType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="生产日期" prop="productionDate"></el-table-column>
        <el-table-column min-width="160" label="产品规格" show-overflow-tooltip prop="specName"></el-table-column>
        <el-table-column min-width="110" label="保质期(月)" prop="shelfLifeMonth"></el-table-column>
        <el-table-column min-width="120" label="保质期至" prop="shelfLifeEndDate"></el-table-column>
        <el-table-column min-width="100" label="生产线" prop="productionLine"></el-table-column>

        <!-- 五项质检状态 -->
        <el-table-column min-width="90" label="标签">
          <template #default="{row}">
            <el-tag :type="row.labelCorrect==='1'?'success':'danger'">
              {{ row.labelCorrect==='1'?'正常':'异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="90" label="喷码">
          <template #default="{row}">
            <el-tag :type="row.sprayCodeCorrect==='1'?'success':'danger'">
              {{ row.sprayCodeCorrect==='1'?'正常':'异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="90" label="压盖">
          <template #default="{row}">
            <el-tag :type="row.capIntact==='1'?'success':'danger'">
              {{ row.capIntact==='1'?'正常':'异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="瓶内杂质">
          <template #default="{row}">
            <el-tag :type="row.bottleImpurity==='1'?'success':'danger'">
              {{ row.bottleImpurity==='1'?'正常':'异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="瓶外壁">
          <template #default="{row}">
            <el-tag :type="row.bottleWallIntact==='1'?'success':'danger'">
              {{ row.bottleWallIntact==='1'?'正常':'异常' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column min-width="120" label="备注" prop="remark" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column min-width="100" label="创建人" prop="createUserName"></el-table-column>
        <el-table-column min-width="160" label="创建时间" prop="ctime"></el-table-column>
        <el-table-column min-width="100" label="复核状态">
          <template #default="{row}">
            <el-tag v-if="row.inspectionType === '1'" :type="row.reviewStatus==='1'?'warning':'primary'">
              {{ row.reviewStatus==='1'?'待复核':'已复核' }}
            </el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="复核人" prop="reviewUserName"></el-table-column>
        <el-table-column min-width="160" label="复核时间" prop="reviewTime"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/productionProcess/detail?checkId=' + row.checkId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/productionProcess/edit?checkId=' + row.checkId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.checkId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'productionProcess',
  mixins: [keepAlive],
  data () {
    return {
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        productionDate: '',
        inspectionType: '',
        checkResult: '',
        specId: ''
      },
      inspectionTypeArr: [
        { label: '生产过程首件检验', value: '1' },
        { label: '生产过程关键控制点', value: '2' }
      ],
      resultArr: [
        { label: '正常', value: '1' },
        { label: '异常', value: '2' }
      ],
      specList: []
    }
  },
  computed: {
    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd () {
      return this.buttonList.includes('add')
    },
    hasExport () {
      return this.buttonList.includes('export')
    },
    hasEdit () {
      return this.buttonList.includes('edit')
    },
    hasDel () {
      return this.buttonList.includes('delete')
    }
  },
  created () {
    this.loadSpec()
    this.loadData()
  },
  methods: {
    loadSpec() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list || []
      })
    },
    deleteRow (checkId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.productionProcess.deletePaProductionInspection, { checkId }).then(() => {
          this.loadData()
        })
      })
    },
    loadData () {
      const params = { page: this.page, ...this.searchForm }
      this.$axios.get(this.$apis.productionProcess.selectPaProductionInspectionByPage, { params }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.searchForm.resetFields()
    },
    formatInspectionType(inspectionType) {
      const item = this.inspectionTypeArr.find(item => item.value === inspectionType)
      return item ? item.label : '--'
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios
        .post(
          this.$apis.productionProcess.exportPaProductionInspection,
          this.searchForm,
          {
            responseType: 'blob'
          }
        )
        .then(res => {
          if (res) {
            const disposition = res.headers['content-disposition']
            const fileName = this.getFileName(disposition)
            this.downloadFile(res.data, fileName)
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    getFileName(disposition) {
      if (!disposition) {
        return '生产过程检查.xls'
      }
      const fileNameStar = disposition.match(/filename\*=UTF-8''([^;]+)/)
      if (fileNameStar && fileNameStar[1]) {
        return fileNameStar[1]
      }
      const fileName = disposition.match(/filename="?([^";]+)"?/)
      return fileName && fileName[1] ? fileName[1] : '生产过程检查.xls'
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
